module.exports = __webpack_public_path__ + "img/logo-um-feri.d7796044.png";